import { z } from "zod";
import { notificationTypeSchema } from "../_shared";

export const unacknowledgedPlatformNotificationsCountByTypePerCompanyResponseSchema =
  z.partialRecord(notificationTypeSchema, z.number().int().min(0));

export type UnacknowledgedPlatformNotificationsCountByTypePerCompanyResponse =
  z.infer<
    typeof unacknowledgedPlatformNotificationsCountByTypePerCompanyResponseSchema
  >;
